export interface ThemeLayout {
    inset: string;
    insetCompact: string;
    measure: {
        prose: number;
        page: number;
    };
    row: {
        default: string;
        media: string;
        group: string;
        menu: string;
    };
    control: string;
}

export function createThemeLayout(spacing: (factor: number) => string): ThemeLayout {
    return {
        inset: spacing(3),
        insetCompact: spacing(2),
        measure: {
            prose: 760,
            page: 1120,
        },
        row: {
            default: "var(--row)",
            media: "var(--row-media)",
            group: "var(--row-group)",
            menu: "var(--row-menu)",
        },
        control: "var(--control)",
    };
}

declare module "@mui/joy/styles" {
    interface Theme {
        layout: ThemeLayout;
    }

    interface TypographySystemOverrides {
        display: true;
        title: true;
        heading: true;
        body: true;
        secondary: true;
        caption: true;
        overline: true;
    }
}
